import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import api, { fileUrl } from "@/lib/api";
import useConsultantPWAManifest from "@/lib/useConsultantPWAManifest";
import { Loader2, Search, ArrowRight } from "lucide-react";
import { toast } from "sonner";

const STATUS_LABEL = { nuova: "Nuova", presa_in_carico: "Presa in carico", in_lavorazione: "In lavorazione", chiusa: "Chiusa" };

export default function ClientPractices() {
  const { slug } = useParams();
  const [code, setCode] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [consultant, setConsultant] = useState(null);

  useConsultantPWAManifest(slug, consultant);

  useEffect(() => {
    api.get(`/consultants/by-slug/${slug}`).then(({ data }) => setConsultant(data)).catch(() => {});
  }, [slug]);

  const check = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResult(null);
    try {
      const { data } = await api.get(`/practices/by-code/${code.toUpperCase().trim()}`);
      setResult(data);
    } catch {
      toast.error("Pratica non trovata");
    } finally {
      setLoading(false);
    }
  };

  const primaryColor = consultant?.brand_color_primary || "#F77F2A";

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <header className="bg-white border-b border-slate-200 safe-top">
        <div className="max-w-md mx-auto px-5 py-3 flex items-center gap-3">
          <Link to={`/c/${slug}`} className="text-sm text-slate-500 hover:text-[#2456C6] shrink-0">← Indietro</Link>
          <div className="flex-1 flex justify-end items-center">
            {consultant?.logo_url ? (
              <div className="rounded-lg bg-white border border-slate-100 p-1 flex items-center justify-center overflow-hidden"
                style={{ width: 90, height: 60 }} data-testid="practices-consultant-logo">
                <img src={fileUrl(consultant.logo_url)} alt={consultant.studio_name} className="w-full h-full object-contain" />
              </div>
            ) : consultant ? (
              <div className="rounded-lg flex items-center justify-center font-black text-white text-sm"
                style={{ width: 90, height: 60, background: primaryColor }} data-testid="practices-consultant-initial">
                {consultant.studio_name?.charAt(0) || "C"}
              </div>
            ) : null}
          </div>
        </div>
      </header>
      <main className="max-w-md mx-auto px-5 py-6">
        <h1 className="text-2xl font-black text-[#1E293B] mb-2">Stato pratica</h1>
        <p className="text-sm text-slate-600 mb-5">Inserisci il codice ricevuto via email.</p>
        <form onSubmit={check} className="card-gs">
          <input data-testid="status-code-input" type="text" required value={code}
            onChange={(e) => setCode(e.target.value)} placeholder="GS-000001"
            className="input-gs uppercase tracking-widest text-center text-lg font-bold mb-3" maxLength={12} />
          <button data-testid="status-check-button" type="submit" disabled={loading} className="btn-gs-primary w-full">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : (<><Search className="w-5 h-5" /> Verifica</>)}
          </button>
        </form>

        {result && (
          <div className="card-gs mt-5">
            <div className="text-xs uppercase tracking-wider text-slate-500 font-bold mb-1">Codice</div>
            <div className="text-2xl font-black text-[#1E293B] mb-3">{result.code}</div>
            <div className="text-sm text-slate-600 mb-2">Cliente: <b>{result.client_name}</b></div>
            <span className={`badge-status badge-${result.status}`}>{STATUS_LABEL[result.status]}</span>
            <div className="mt-4 space-y-1 text-sm">
              <div>Firma OTP: {result.signature_otp_verified ? "✓ Confermata" : "— In attesa"}</div>
              <div>Firma Email: {result.signature_email_confirmed ? "✓ Confermata" : "— In attesa"}</div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}
